import {action, autorun, computed, makeObservable, observable} from 'mobx'
import User from '../models/User'
import {post} from "../common/requester";
import Company from "../models/Company";

class NewStore {
  company = new Company()
  pending_companies = []
  
  constructor() {
    makeObservable(this, {
      company: observable,
      setProperty: action,
      resetCompany: action,
      checkPendingCompanies: action,
      pending_companies: observable,
      remindAdmin: action
    })
  }

  setProperty(key, value) {
    this[key] = value
  }

  resetCompany() {
    this.company = new Company()
  }

  async checkPendingCompanies() {
    const res = await post('check_pending_companies', {}).catch((err) => console.error('--pending error', err))
    if (res) {
      this.setProperty('pending_companies', res.companies)
    }
  }

  async remindAdmin(companyId) {
      return post('company/remind_admin', {company_id: companyId})
  }
}
const newStore = new NewStore();
export default newStore;